import AbstractService, {
  InterfaceInflux,
  ServiceInflux
} from "./AbstractService";

/**
 * InfluxService
 */
export default class InfluxService extends AbstractService implements InterfaceInflux {
  /**
   * ServiceInflux
   */
  static service: ServiceInflux;

  /**
   * constructor
   */
  constructor() {
    super();

    InfluxService.service = this.getApi().getServiceInflux();
  }

  /**
   * clientData
   */
  clientData(fromDateTime: Date, toDateTime: Date, resolution: string): Promise<any> {
    return InfluxService.service.clientData(fromDateTime, toDateTime, resolution);
  }

  /**
   * performanceSupplierData
   */
  performanceSupplierData(fromDateTime: Date, toDateTime: Date): Promise<any> {
    //let httpService = InfluxService.service.getHttpService();

    //httpService.registerRequestScopeEmitter("interlink-api:performanceSupplierData");
    //httpService.registerResponseScopeEmitter("interlink-api:performanceSupplierData");

    return InfluxService.service.performanceSupplierData(fromDateTime, toDateTime);
  }

  /**
   * performanceCustomerData
   */
  performanceCustomerData(fromDateTime: Date, toDateTime: Date): Promise<any> {
    //let httpService = InfluxService.service.getHttpService();

    //httpService.registerRequestScopeEmitter("interlink-api:performanceCustomerData");
    //httpService.registerResponseScopeEmitter("interlink-api:performanceCustomerData");

    return InfluxService.service.performanceCustomerData(fromDateTime, toDateTime);
  }
}
